/**
 * PendienteCell Component - Data Display
 * Renders an amber "PENDIENTE" indicator for fields the backend does not yet expose.
 * Used in tables/detail views as a visual placeholder while data is missing.
 * See PENDIENTES.md for tracking of pending backend fields.
 */

export function PendienteCell() {
  return (
    <span
      className="text-xs font-medium text-amber-500"
      title="Pendiente: backend no expone este campo todavia (ver PENDIENTES.md)"
    >
      PENDIENTE
    </span>
  );
}
